import Environment from "../../../environment";

import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { PagoService } from 'services/PagoService';
import useRequest from 'hooks/useRequest';
import { useStore } from "store/context";

import numberFormatter from 'hooks/numberFormatter';

import GradientButton from 'components/atoms/GradientButton';
import MainLayout from 'components/Layouts/MainLayout';

import Box from "components/atoms/Box";

import pagos360 from 'assets/images/pagos360.png';
import imprimir from 'assets/images/imprimir.png';

import Modal from 'components/atoms/Modal';

import './styles.scss';

const MetodosPagosView = (props) => {
    const history = useHistory();

    const {
        loadingSpinner, success, message,
        beforeSubmit, afterSubmit,
        dealWithError
    } = useRequest();

    const [{
        uf,  // La uf actual seleccionada
        facturasLastUf,  // La uf a la que pertenecen las facturas cargadas
        facturas,  // El listado de facturas
    }, dispatch] = useStore();

    const titleDebito = <>
        <strong>UF</strong> {uf.unidad} - {uf.alias}
    </>;

    const [fechaVtoDentro, setFechaVtoDentro] = useState(addDays(new Date(), 3));
    const [fechaVto, setFechaVto] = useState(new Date());
    const [facturasSeleccionadas, setFacturasSeleccionadas] = useState([]);

    const [deudaAEnviar, setDeudaAEnviar] = useState([]);

    const [showMetodoPago, setShowMetodoPago] = useState(false);

    const handleCloseMetodoPago = () => {
        setShowMetodoPago(false);
    }

    const bodyMetodoPago = <span className="confirmar-baja-body">
        <h3>MÉTODO DE PAGO</h3>
        <div className="confirmar-baja-container">
            <div className="confirmar-baja-content baja-confirmar">

                {(success === false && message) &&
                    <p className="confirmar-baja-mensaje">{message}</p>
                }

                <div className="confirmar-baja-button">
                    <GradientButton legend={'CERRAR'} handleClick={handleCloseMetodoPago} />
                </div>
            </div>
        </div>
    </span>;

    const {
        currency
    } = numberFormatter();

    useEffect(() => {

        if (facturas.length === 0) {
            history.push('/consulta_descarga_facturas');
        }

        setFacturasSeleccionadas(facturas.filter(function (factura) {
            return factura.isChecked;
        }).map(function (factura) {
            return {
                "tpo_com": factura.tpo_com,
                "pre_com": factura.pre_com,
                "num_com": factura.num_com
            };
        }));

        setDeudaAEnviar(facturas.reduce(function (prev, current) {
            if (current.isChecked && current.seleccionable) {
                return prev + +current.ajustado
            } else {
                return prev + +0.00
            }
        }, 0.00));

    }, []);

    function addDays(date, days) {
        return date.setDate(date.getDate() + days);;
    }

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    function formatDateMetodo(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }

    const consultaYDescarga = (e) => {
        e.preventDefault();

        history.goBack();
    };

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    const openSameNewTab = (url) => {
        const newWindow = window.open(url, '_self', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    const pagarHoy = (e) => {
        e.preventDefault();
        beforeSubmit();
        const data = {
            fecha_vto: formatDate(fechaVto),
            comprobantes: facturasSeleccionadas,
        }
        PagoService.pago360(data, uf.id)
            .then(data => {
                afterSubmit();
                dispatch({
                    type: 'setFacturas',
                    payload: [],
                });
                dispatch({
                    type: 'setFacturasLastUf',
                    payload: {},
                });
                openSameNewTab(data['checkout_url']);
            }).catch((error) => {
                setShowMetodoPago(true);
                dealWithError(error, '');
            });
    };

    const imprimirHoy = (e) => {
        e.preventDefault();
        beforeSubmit();
        const data = {
            fecha_vto: formatDate(fechaVto),
            comprobantes: facturasSeleccionadas,
        }
        PagoService.pagoManual(data, uf.id)
            .then(data => {
                afterSubmit();
                openInNewTab(`${Environment.api}api/unidades-facturaciones/${uf.id}/pagos/${data.id}/imprimir`);
            }).catch((error) => {
                setShowMetodoPago(true);
                dealWithError(error, '');
            });
    };

    const imprimirDentro = (e) => {
        e.preventDefault();
        beforeSubmit();
        const data = {
            fecha_vto: formatDate(fechaVtoDentro),
            comprobantes: facturasSeleccionadas,
        }
        PagoService.pagoManual(data, uf.id)
            .then(data => {
                afterSubmit();
                openInNewTab(`${Environment.api}api/unidades-facturaciones/${uf.id}/pagos/${data.id}/imprimir`);
            }).catch((error) => {
                setShowMetodoPago(true);
                dealWithError(error, '');
            });
    };

    return (<>
        <MainLayout>
            <h1>Elegí un método de pago</h1>
            <div className="metodos-pagos-volver">
                <GradientButton legend={'VOLVER'} handleClick={consultaYDescarga} />
            </div>
            <div className="metodos-pagos-boxes">
                <div className="metodos-pagos-box-online">
                    <Box header='ONLINE' body={
                        <div className="metodos-pagos-info">
                            <div className="metodos-pagos-cuadro" onClick={pagarHoy}>
                                <h2>AHORA</h2>
                                <p><img src={pagos360} /></p>
                            </div>
                            <div className="metodos-pago-vencimientoytotal">
                                <p>Vencimiento: {formatDateMetodo(fechaVto)}</p>
                                <p>Total: <strong>$ {currency.format(deudaAEnviar)}</strong></p>
                            </div>
                        </div>
                    }>
                    </Box>
                </div>
                <div className="metodos-pagos-box-manual">
                    <Box header='MEDIANTE COMPROBANTE' body={
                        <>
                            <div className="metodos-pagos-info">
                                <div className="metodos-pagos-cuadro" onClick={imprimirHoy}>
                                    <h2>HOY</h2>
                                    <p><img src={imprimir} />IMPRIMIR</p>
                                </div>
                                <div className="metodos-pago-vencimientoytotal">
                                    <p>Vencimiento: {formatDateMetodo(fechaVto)}</p>
                                    <p>Total: <strong>$ {currency.format(deudaAEnviar)}</strong></p>
                                </div>
                            </div>
                            <div className="metodos-pagos-info metodos-pagos-dentro">
                                <div className="metodos-pagos-cuadro" onClick={imprimirDentro}>
                                    <h2>DENTRO DE 3 DÍAS</h2>
                                    <p><img src={imprimir} />IMPRIMIR</p>
                                </div>
                                <div className="metodos-pago-vencimientoytotal">
                                    <p>Vencimiento: {formatDateMetodo(fechaVtoDentro)}</p>
                                    <p>Total: <strong>$ {currency.format(deudaAEnviar)} + recargos por 3 días</strong></p>
                                </div>
                            </div>
                        </>
                    }>
                    </Box>
                </div>
            </div>
            <h3 className="facturacion-nota">Nota: Si el comprobante no se descarga, verifica la configuración de ventanas emergentes y redirecciones del navegador.</h3>
        </MainLayout>
        <Modal className="modal-debito-automatico" title={titleDebito} body={bodyMetodoPago} legend={""} handleClose={handleCloseMetodoPago} show={showMetodoPago}></Modal>
    </>
    );
}

export default withTranslation()(MetodosPagosView);